import { ecommerceModal } from './ecommerceModal'
import { updateNodeConnections } from '../../functions/utils'

// eslint-disable-next-line no-unused-vars
export default async (node, editor) => {
  const oldData = node.data
  const { value: ecommerceData } = await ecommerceModal(oldData, node)

  if (ecommerceData && Object.values(ecommerceData).length > 0) {
    Object.assign(node.data, ecommerceData)
    node.update()
    updateNodeConnections(node)
  }


  return false
}